module.exports = __webpack_public_path__ + "static/media/Imagen_6.e11ac95d.jpg";